/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerSubmitQueryMutationResponse, ChatControllerSubmitQuery400, ChatControllerSubmitQuery401, ChatControllerSubmitQuery403 } from "../../models/chatController/ChatControllerSubmitQuery";

function getChatControllerSubmitQueryUrl() {
  const res = { method: 'POST', url: `/api/v1/chat/query` as const }  
  return res
}

/**
 * @summary Submit a chat query
 * {@link /api/v1/chat/query}
 */
export async function chatControllerSubmitQuery(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ChatControllerSubmitQueryMutationResponse, ResponseErrorConfig<ChatControllerSubmitQuery400 | ChatControllerSubmitQuery401 | ChatControllerSubmitQuery403>, unknown>({ method : "POST", url : getChatControllerSubmitQueryUrl().url.toString(), ... requestConfig })  
  return res.data
}